var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 px-4 bg-gray-200 shadow-md rounded dark:bg-gray-800 w-full h-full"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }